import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../../../ts/ServerApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../../ts/ServerApi/types/IGetItemsResult';
import { IGroup } from '../../../ts/ServerApi/types/IGroup';
import { IUser } from '../../../ts/ServerApi/types/IUser';
import { IDataAlert } from '../types/IDataAlert';

export interface IGetDataAlertsResult extends IGetItemsResult {
  dataAlerts: IDataAlert[];
  users: IUser[];
  groups: IGroup[];
}

export class GetDataAlertsRequest extends Request<IGetItemsParams, IGetDataAlertsResult> {
  constructor(params: IGetItemsParams) {
    super('getDataAlerts', params);
  }
}
